require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-charlie-crawford.json") })
        }
      }, "path---blog-author-charlie-crawford");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-charlie-crawford!./.cache/json/blog-author-charlie-crawford.json
// module id = 616
// module chunks = 231608221292675